import axios from 'axios-observable';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import CONFIG from '../../settings';
import { CreateThresholdBody, Threshold, ThresholdListResponse, UpdateThresholdBody } from './models';

const baseUrl = `${CONFIG.protectorApiUrl}/v2/regional-overview/digital-trap-thresholds`;

export const getThresholds = (): AxiosObservable<ThresholdListResponse> => {
  return axios.get<ThresholdListResponse>(baseUrl);
};

export const createThreshold = (body: CreateThresholdBody): AxiosObservable<Threshold> => {
  return axios.post<Threshold>(baseUrl, body);
};

export const updateThreshold = (id: string, body: UpdateThresholdBody): AxiosObservable<Threshold> => {
  return axios.put<Threshold>(`${baseUrl}/${id}`, body);
};

export const deleteThreshold = (id: string): AxiosObservable<{ id: string; deleted: boolean }> => {
  return axios.delete<{ id: string; deleted: boolean }>(`${baseUrl}/${id}`);
};
